export default "__VITE_ASSET__DVVMPjLx__"